<template>
  <div>
    <page-title icon="fas fa-receipt" main="Venda Direta">
      <template v-slot:actions>
        <base-button
          @click="modals.modal0 = true"
          type="info"
          class="ml-3"
          size="sm"
          >Cadastrar</base-button
        >
      </template>
    </page-title>
    <div class="card mt-2" style="padding: 0rem 1rem">
      <div class="row">
          <div  class="col-lg-12 card-header">
            <h5 class="h3 mb-0">Venda Direta</h5>
            <h6 class="text-uppercase text-muted ls-1 mb-1"> Configure quais dados deverão ser listados:  </h6>
          </div>
        <base-input group class="mb-0 col-6 mt-3">
          <input
            type="text"
            class="form-control"
            v-model="filter"
            placeholder="Informe o nome do Cliente"
            aria-label="Recipient's username"
            aria-describedby="button-addon2"
          />
          <div class="input-group-append">
            <base-button outline type="info" id="button-addon2" @click="search"
              >Pesquisar</base-button
            >
            <base-button
              type="secondary"
              class="ml-4"
              @click="clearFilters">
              Limpar Pesquisa
            </base-button>
          </div>
        </base-input>
      </div>
      <!-- Transform modal component -->
      <modal :show.sync="modals.modal0" id="anosafra" size="lg">
        <template slot="header">
          <h5 class="modal-title" id="exampleModalLabel">Nova Venda Direta</h5>
        </template>
        <form role="form" @submit.prevent="save">
          <div class="row">
            <div class="col-md-6">
              <base-input
                type="text"
                label="Nome do Fornecedor"
                placeholder="Nome do Forncedor"
                v-model="nameProvider"
                :required="true"
                aria-label="Nome do Fornecedor"
              ></base-input>
            </div>
            <div class="col-md-6">
              <base-input
                type="number"
                label="Número da Nota"
                placeholder="Número da Nota"
                v-model="numberNote"
                :required="true"
                aria-label="Número de Nota"
              />
            </div>
            <div class="col-md-6">
              <base-input
                type="text"
                label="Descrição"
                placeholder="Descrição"
                v-model="description"
                :required="true"
                aria-label="Descrição"
              />
            </div>
            <div class="col-md-6">
              <label class="form-control-label">Cliente</label><br />
              <multiselect
                v-model="nameClient"
                :select-label="''"
                :deselect-label="''"
                :selected-label="'Selecionado'"
                :options="clients"
                label="razao_social"
                placeholder="Selecionar Cliente"
                track-by="id"
                @search-change="getClients"
              />
            </div>
            <div class="col-md-6">
              <base-input
                type="number"
                label="Série"
                placeholder="Número de série"
                v-model="serie"
                :required="true"
                aria-label="Descrição"
              />
            </div>
            <div class="col-md-6">
              <base-input
                mask="money"
                label="Valor"
                placeholder="120.000,00"
                v-model="value"
                :required="true"
                aria-label="Valor"
              />
            </div>
            <div class="col-md-6">
              <label class="form-control-label">Grupo</label><br />
              <multiselect
                v-model="valueGrups"
                :options="groups"
                label="descricao"
                :select-label="''"
                :deselect-label="''"
                :selected-label="'Selecionado'"
                placeholder="Selecionar Grupo"
                track-by="id"
              />
            </div>
            <div class="col-md-6">
              <label class="form-control-label">Data</label><br />
              <el-date-picker
                v-model="date"
                prefix-icon="fa fa-calendar"
                format="d 'de' MMMM 'de' yyyy"
              >
              </el-date-picker>
            </div>
            <div class="col-md-6 mt-4">
              <label class="form-control-label">Gerente</label><br />
              <multiselect
                v-model="valueManager"
                :options="optionManager"
                label="name"
                :select-label="''"
                :deselect-label="''"
                :selected-label="'Selecionado'"
                placeholder="Selecionar Gerente"
                track-by="id"
              />
            </div>
            <div class="col-md-6 mt-4">
              <label class="form-control-label">Vendedor</label><br />
              <multiselect
                v-model="valueSalesman"
                :options="optionSalesman"
                label="name"
                :select-label="''"
                :deselect-label="''"
                :selected-label="'Selecionado'"
                placeholder="Selecionar Vendedor"
                track-by="id"
              />
            </div>
          </div>
        </form>
        <template slot="footer">
          <base-button class="mr-2" type="secondary" @click="modals.modal0 = false"
            >Fechar</base-button
          >
          <base-button  type="info" @click="save">Salvar</base-button>
        </template>
      </modal>

      <modal :show.sync="modals.modal1" id="anosafra-edit" size="lg">
        <template slot="header">
          <h5 class="modal-title" id="exampleModalLabel">
            Editar Venda Direta
          </h5>
        </template>
        <form role="form" @submit.prevent="save">
          <div class="row">
            <div class="col-md-6">
              <div class="space">
                <label class="form-control-label">Nome do Fornecedor</label
                ><br />
                <input
                  type="text"
                  class="form-control"
                  placeholder="Nome do Forncedor"
                  v-model="venda.name"
                  aria-label="Nome do Fornecedor"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="space">
                <label class="form-control-label">Número da Nota</label><br />
                <input
                  type="number"
                  class="form-control"
                  placeholder="Número da Nota"
                  v-model="venda.number_note"
                  aria-label="Número de Nota"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="space">
                <label class="form-control-label">Descrição</label><br />
                <input
                  type="text"
                  class="form-control"
                  placeholder="Descrição"
                  v-model="venda.description"
                  aria-label="Descrição"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="space">
                <label class="form-control-label">Cliente</label><br />
                <multiselect
                  v-model="venda.client"
                  :options="clients"
                  :disabled="true"
                  label="razao_social"
                  :select-label="''"
                  :deselect-label="''"
                  :selected-label="'Selecionado'"
                  placeholder="Selecionar Cliente"
                  track-by="id"
                  @search-change="getClients"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="space">
                <label class="form-control-label">Série</label><br />
                <input
                  type="number"
                  class="form-control"
                  placeholder="Número de série"
                  v-model="venda.serie"
                  aria-label="Descrição"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="space">
                <label class="form-control-label">Valor</label><br />
                <input
                  type="number"
                  class="form-control"
                  placeholder="120.000,00"
                  v-model="venda.value"
                  aria-label="Valor"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="space">
                <label class="form-control-label">Grupo</label><br />
                <multiselect
                  v-model="venda.group"
                  :options="groups"
                  :disabled="true"
                  :select-label="''"
                  :deselect-label="''"
                  :selected-label="'Selecionado'"
                  placeholder="Selecionar Grupo"
                  track-by="id"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="space">
                <label class="form-control-label">Data</label><br />
                <el-date-picker
                  v-model="venda.date"
                  prefix-icon="fa fa-calendar"
                  format="d 'de' MMMM 'de' yyyy"
                >
                </el-date-picker>
              </div>
            </div>
            <div class="col-md-6">
              <div class="space">
                <label class="form-control-label">Gerente</label><br />
                <multiselect
                  v-model="venda.is_manager"
                  :options="optionManager"
                  :disabled="true"
                  placeholder="Selecionar Gerente"
                  :select-label="''"
                  :deselect-label="''"
                  :selected-label="'Selecionado'"
                  track-by="id"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="space">
                <label class="form-control-label">Vendedor</label><br />
                <multiselect
                  v-model="venda.is_salesman"
                  :options="optionSalesman"
                  :disabled="true"
                  :select-label="''"
                  :deselect-label="''"
                  :selected-label="'Selecionado'"
                  placeholder="Selecionar Vendedor"
                />
              </div>
            </div>
          </div>
        </form>
        <template slot="footer">
          <base-button  type="secondary" @click="modals.modal1 = false"
            >Fechar</base-button
          >
          <base-button type="success" @click="editVenda">Salvar</base-button>
        </template>
      </modal>

      <div class="border-0 ">
        <h3 class="mb-2 ml-2">Vendas Diretas Cadastradas:</h3>
      </div>

      <el-table
        v-loading="isLoading"
        :data="directSale"
        class="table-responsive table-striped"
        header-row-class-name="thead-light"
        border
        style="width: 100%"
      >
        <el-table-column
          label="Nome"
          prop="name"
          sortable
          style="width: 60%"
          v-slot="{ row }"
        >
          {{ row.name }}
        </el-table-column>

        <el-table-column
          label="Número"
          prop="number_note"
          sortable
          v-slot="{ row }"
        >
          {{ row.number_note }}
        </el-table-column>

        <el-table-column
          label="Valor"
          width="180px"
          prop="value"
          v-slot="{ row }"
        >
          {{
            row.value.toLocaleString("pt-BR", {
              style: "currency",
              currency: "brl",
            })
          }}
        </el-table-column>

        <el-table-column
          width="180px"
          label="Data"
          prop="date"
          v-slot="{ row }"
          sortable
        >
          {{ row.date | formatDate }}
        </el-table-column>

        <el-table-column
          label="Ações"
          width="80px"
          prop="acoes"
          v-slot="{ row }"
        >
          <el-dropdown trigger="hover" class="dropdown" style="cursor: pointer">
            <span class="btn btn-sm btn-icon-only text-success">
              <i class="fas fa-ellipsis-v mt-2"></i>
            </span>
            <el-dropdown-menu
              class="dropdown-menu dropdown-menu-arrow show"
              slot="dropdown"
            >
              <a class="dropdown-item" href="#" @click="edit(row)">Editar</a>
              <a class="dropdown-item" href="#" @click="remove(row)">Excluir</a>
            </el-dropdown-menu>
          </el-dropdown>
        </el-table-column>
      </el-table>
      <div class="card-footer py-4 d-flex justify-content-end">
        <base-pagination
          v-model="paginated_data['current']"
          :total="paginated_data['count']"
          :perPage="paginated_data['per_page']"
        >
        </base-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import PageTitle from "@/layouts/PageTitle";
import flatPicker from "vue-flatpickr-component";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";


import "flatpickr/dist/flatpickr.css";
import { Portuguese } from "flatpickr/dist/l10n/pt.js";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Cascader,
  DatePicker,
} from "element-ui";
import { ValidationProvider, extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";

extend("required", {
  ...required,
  message: "Este campo é obrigatório",
});
export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    Multiselect,
    [Cascader.name]: Cascader,
    flatPicker,
    PageTitle,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [DatePicker.name]: DatePicker,
  },
  data() {
    return {
      active: true,
      filter: "",
      filtered: false,
      freeArray: [],
      directSale: [],
      forAllClients: false,
      forAllSalesmans: false,
      forAllManagers: false,
      modals: {
        modal0: false,
        modal1: false,
      },
      clients: [],
      groups: [],
      optionManager: [],
      optionSalesman: [],
      optionCoordinator: [],
      valueCoordinator: null,
      valueManager: null,
      valueSalesman: null,
      valueClient: null,
      valueGrups: null,
      nameProvider: null,
      numberNote: null,
      description: null,
      nameClient: null,
      serie: null,
      date: null,
      isLoading: false,
      value: null,
      venda: {},
      paginated_data: [],
      item: "",
      config: {
        altInput: false,
        allowInput: true,
        dateFormat: "d/m/Y",
        locale: Portuguese,
      },
    };
  },
  mounted() {
    this.getDirectSale();
    this.getClients();
    this.getGroups();
    this.getManagers();
    this.initSalesmen();
    this.initCoordinator();
  },
  methods: {
    getDirectSale() {
      this.isLoading = true;
      this.$http.secured
        .get(`/api/v1/direct_sellings`, {})
        .then((response) => {
          this.directSale = response.data;
          console.log("dado tabela",this.directSale);
          this.isLoading = false;

        })
        .catch((error) => this.setError(error, "Something went wrong"));
    },
    save() {
      if(this.value != null && this.nameProvider != ""){
      this.$http.secured
        .post(`/api/v1/direct_sellings`, {
          name:           this.nameProvider,
          description:    this.description,
          client:         this.nameClient       && this.nameClient.name,
          group:          this.valueGrups       && this.valueGrups.descricao,
          is_salesman:    this.valueSalesman    && this.valueSalesman.name,
          is_manager:     this.valueManager     && this.valueManager.name,
          is_coordinator: this.valueCoordinator && this.valueCoordinator.name,
          salesman_id:    this.valueSalesman    && this.valueSalesman.id,
          manager_id:     this.valueManager     && this.valueManager.id,
          coordinator_id: this.valueCoordinator && this.valueCoordinator.id,
          value:          this.value,
          serie:          this.serie,
          date:           this.date,
          number_note:    this.numberNote,
        })
        .then((response) => {
          this.getDirectSale();
          this.limpCampos();
        })
        .catch((error) => this.setError(error, "Something went wrong"));
      this.modals.modal0 = false;
      }
    },
    limpCampos() {
      this.nameProvider = "";
      this.description = "";
      this.nameClient = "";
      this.valueGrups = "";
      this.valueSalesman = "";
      this.valueManager = "";
      this.valueCoordinator = "";
      this.value = null;
      this.serie = null;
      this.date = "";
      this.numberNote = null;
    },
    remove(venda) {
      if (confirm("Deseja excluir a Venda Direta " + `${venda.name}` + "?")) {
        this.$http.secured
          .delete(`/api/v1/direct_sellings/${venda.id}`, venda)
          .then((response) => {
            this.getDirectSale();
          })
          .catch((error) => this.setError(error, "Cannot delete venda direta"));
      }
    },
    edit(venda) {
      this.venda = venda;
      this.modals.modal1 = true;
    },
    editVenda() {
      this.$http.secured
        .put(`/api/v1/direct_sellings/${this.venda.id}`, this.venda)
        .then((response) => {
          this.getDirectSale();
        })
        .catch((error) => this.setError(error, "Something went wrong"));
      this.modals.modal1 = false;
    },
    formatDate(dateString) {
      let dateParts = dateString.split(" / ");
      return finalString;
    },
    getClients(query) {
      var queryObj = null;
      if (typeof query != "undefined" && query != "") {
        queryObj = {
          razao_social: query,
        };
      }
      this.$http.secured
        .get("/api/v1/clients", {
          params: {
            q: queryObj,
          },
        })
        .then((response) => {
          this.clients = response.data["clients"]
            ? response.data["clients"]
            : [];
        })
        .catch((error) => this.setError(error, "Something went wrong"));
    },
    getGroups() {
      this.$http.secured.get("/api/v1/grupos").then((response) => {
        this.groups = response.data;
      });
    },
    getManagers() {
      this.$http.secured
        .get("/api/v1/users/", {
          params: {
            unpaged: true,
            q: { is_manager: true }
          },
        })
        .then((response) => {
          this.optionManager = response.data;
        })
        .catch((error) => this.setError(error, "Something went wrong"));
    },
    initSalesmen(query) {
      var data = {
        name_only: true,
        q: { name: query, is_salesman: true, status: this.active },
      };

      this.$http.secured
        .get("/api/v1/users", { params: data })
        .then((response) => {
          this.optionSalesman = response.data || [];
        })
        .catch((error) => this.setError(error, "Something went wrong"));
    },
    initCoordinator(query) {
      var data = {
        name_only: true,
        q: { name: query, is_coordinator: true, status: this.active },
      };

      this.$http.secured
        .get("/api/v1/users", { params: data })
        .then((response) => {
          this.optionCoordinator = response.data || [];
        })
        .catch((error) => this.setError(error, "Something went wrong"));
    },
    search() {
      let name = this.filter;
      this.$http.secured
        .get("/api/v1/direct_sellings", {
          params: {
            "direct_selling[name]": name ? name : null,
          },
        })
        .then((response) => {
          this.directSale = response.data;
          console.log("dado filtro",this.directSale);
        })
        .catch((error) => this.setError(error, "Something went wrong"));
    },
    clearFilters() {
      this.filter = ""
    },
  },
  computed: {},
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css">
</style>
<style scoped>
.cascader {
  width: 360px;
}
.space {
  padding: 10px;
}
</style>
